import { PHOTOS } from "@/assets/photos";
import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";

import { PageHero, Section } from "@/components/site/section";
import { squadQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/squad")({
  head: () => ({
    meta: [
      { title: "Argentina Squad | Argentinian.Soccer" },
      { name: "description", content: "The current Argentina National Team squad." },
      { property: "og:title", content: "Argentina Squad | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/squad" },
    ],
    links: [{ rel: "canonical", href: "/national-team/squad" }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(squadQuery("senior")),
  component: SquadPage,
});

function SquadPage() {
  const { data } = useSuspenseQuery(squadQuery("senior"));
  const grouped = ["GK", "DF", "MF", "FW"].map((pos) => ({
    pos,
    label: { GK: "Goalkeepers", DF: "Defenders", MF: "Midfielders", FW: "Forwards" }[pos]!,
    players: data.filter((p) => p.position === pos),
  }));

  return (
    <>
      <PageHero eyebrow="National Team" title="Argentina Squad" image={PHOTOS.teamLineup} />
      {grouped.map((g) => (
        <Section key={g.pos} eyebrow={g.pos} title={g.label}>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {g.players.map((p) => (
              <div key={p.id} className="flex items-center justify-between rounded-lg border border-border bg-card p-4">
                <div>
                  <p className="font-display text-base font-bold text-navy">{p.name}</p>
                  <p className="text-xs text-muted-foreground">{p.club}</p>
                  <p className="mt-1 text-xs text-muted-foreground">{p.caps} caps · {p.goals} goals</p>
                </div>
                <span className="font-display text-2xl font-bold text-primary">{p.shirt_number}</span>
              </div>
            ))}
          </div>
        </Section>
      ))}
    </>
  );
}
